<template>
  <base-section id="theme-features-3">
    <v-container>
      <v-row class="pt-5">
        <v-col v-for="(feature, i) in features" :key="i" cols="12" md="6">
          <base-avatar-card v-bind="feature" align="left" horizontal />
        </v-col>
      </v-row>
      <v-col md="6" lg="6" sm="12" align-self="center" class="mx-auto">
        <v-img src="@/assets/Employment12.webp" />
      </v-col>
    </v-container>
  </base-section>
</template>

<script>
export default {
  name: "SectionThemeFeatures",

  data: () => ({
    features: [
      {
        color: "#0BA137",
        dark: true,
        title: "CONTRACT MANAGEMENT MADE SIMPLE",
        icon: "mdi-file",
        text:
          "Our system simplifies contract management with a single-click contract generation feature. Say goodbye to manual document creation and effortlessly generate contracts with ease."
      },
      {
        color: "#0BA137",
        dark: true,
        title: "EFFORTLESS E-SIGNATURE PROCESS",
        icon: "mdi-pen",
        text:
          "Join the green revolution by signing contracts electronically. Our eSign feature eliminates the need for printing, signing, and scanning documents, saving time and reducing paper waste."
      },
      {
        color: "#0BA137",
        dark: true,
        title: "DATA PROTECTION AND PRIVACY",
        icon: "mdi-security",
        text:
          "Rest assured, you will always own your data. We prioritize data protection and privacy, providing you with the peace of mind that your information is secure and confidential."
      },
      {
        color: "#0BA137",
        dark: true,
        title: "DEDICATED EMPLOYER PORTAL",
        icon: "mdi-account",
        text:
          "We understand the importance of efficient communication between employers and your agency. Our dedicated Employer Portal ensures a seamless experience for employers, allowing them to access and manage their contracts conveniently."
      },
      {
        color: "#0BA137",
        dark: true,
        title: "NLP-BASED ANALYTICS",
        icon: "mdi-robot",
        text:
          "Leveraging the power of Natural Language Processing (NLP), our system integrates advanced analytics into the contract generation process. This enables efficient matching of employers and employees, improving the overall recruitment process."
      },
      {
        color: "#0BA137",
        dark: true,
        title: "FEEDBACK MODULE",
        icon: "mdi-message-text",
        text:
          "Maintaining a transparent and constructive relationship with employers and foreign domestic workers (FDWs) is essential. Our Feedback Module allows you to record and manage employer and FDW feedback, enabling continuous improvement and better service delivery."
      },
      {
        color: "#0BA137",
        dark: true,
        title: "SECURE CLOUD STORAGE WITH E-DOCKET",
        icon: "mdi-docker",
        text:
          "Keep your case documents organized and secure with our E-Docket feature. Store and access your important documents in a secure cloud storage system, eliminating the hassle of physical paperwork."
      },
      {
        color: "#0BA137",
        dark: true,
        title: "DETAILED AUDIT TRAIL",
        icon: "mdi-magnify",
        text:
          'Have full visibility into your operations with our comprehensive audit trail. Our system answers the essential questions of "Who did what and when," ensuring accountability and transparency.'
      },
      {
        color: "#0BA137",
        dark: true,
        title: "EFFICIENT PLANNER",
        icon: "mdi-clipboard-text",
        text:
          "With a user-friendly interface, it allows you to oversee all contract executions at a single glance, Stay on top of critical deadlines and never miss a contract renewal with automated notifications, ensuring seamless continuity. Additionally, Efficient Planner enables you to create personalized checklists for each contract, tailoring them to your specific requirements. Assign these checklists to your staff, ensuring everyone is on the same page and responsibilities are clearly defined."
      },
      {
        color: "#0BA137",
        dark: true,
        title: "FLEXIBLE SUBSCRIPTION MODEL",
        icon: "mdi-cursor-default",
        text:
          "We believe in providing an affordable and flexible subscription model. Choose the plan that suits your agencys needs and scale as your business grows"
      },
      {
        color: "#0BA137",
        dark: true,
        title: "INSIGHTFUL REPORTS",
        icon: "mdi-chart-bar",
        text:
          "Access detailed administrative and analytics reports to gain valuable insights into your agencys performance. Make data-driven decisions and optimize your operations for maximum efficiency."
      },
      {
        color: "#0BA137",
        dark: true,
        title: "ROLE-BASED ACCESS CONTROL",
        icon: "mdi-lock-open",
        text:
          "Maintain control over access and permissions with our role-based access control feature. Assign appropriate access levels to your team members, ensuring data security and confidentiality."
      },
      {
        color: "#0BA137",
        dark: true,
        title: "CUSTOMIZABLE TO YOUR WORKFLOW",
        icon: "mdi-arrow-expand",
        text:
          "We understand that every agency has unique requirements. Our system is fully extendable and can be customized to suit your specific workflow, accommodating your agencys processes and preferences."
      },
      {
        color: "#0BA137",
        dark: true,
        title: "ENHANCED SECURITY WITH ZERO TRUST",
        icon: "mdi-shield",
        text:
          "We prioritize security with our Zero Trust functionality and field-level masking. Protect sensitive data and prevent unauthorized access, ensuring comprehensive data protection at all times."
      },
      {
        color: "#0BA137",
        dark: true,
        title: "PRIVATE CLOUD DEPLOYMENT",
        icon: "mdi-cloud",
        text:
          "Comply with regulations and maintain data ownership with our private cloud deployment option. Enjoy enhanced security, control, and peace of mind knowing that your data is stored in a secure and compliant environment."
      },
      {
        color: "#0BA137",
        dark: true,
        title: "DOCUSIGN/ DROPBOX INTEGRATION",
        icon: "mdi-dropbox",
        text:
          "Privately store and manage your contracts within your company's cloud account, securely managed by us or hosted on your own server. Your data never leaves your selected region."
      },
      {
        color: "#0BA137",
        dark: true,
        title: "UPLOAD AND MANAGE CONTRACTS USING MS WORD DOCUMENT",
        icon: "mdi-file-word",
        text:
          "Easily upload and efficiently manage contracts using customizable MS Word templates within our contract management system."
      },
      {
        color: "#0BA137",
        dark: true,
        title: "Check List Management",
        icon: "mdi-list-status",
        text:
          "Manage checklists for employment contracts by creating multiple checklists and assigning them to employees or contracts."
      },
      {
        color: "#0BA137",
        dark: true,
        title: "Bulk contract import and contract expiry notifications",
        icon: "mdi-import",
        text:
          "Enabling effortless management of contract imports and timely notifications for contract expiries"
      },
      {
        color: "#0BA137",
        dark: true,
        title: " ",
        icon: "mdi-cogs",
        text:
          "Our contract management system seamlessly integrates with major HRIS systems and other ERP systems for enhanced efficiency and compatibility."
      }
    ]
  })
};
</script>
